import styled from 'styled-components';

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Head = styled.div`
  margin: 0 5px 0 20px;
  color: #fff;
  font-size: 14px;
  text-align: right;
  line-height: 1;
`;
